import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import ForSale from './ForSale';

const root = ReactDOM.createRoot(
    document.getElementById('root')
);
root.render(
    <React.StrictMode>
        <ForSale />
    </React.StrictMode>
);
